import React from "react";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemTmdbBtnV2 from "../../../shared/itemTmdbBtnV2/itemTmdbBtnV2";
import UseSquadflixNavigate from "../useSquadflixNavigate";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useSquadflixOriginalsData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onMovieClick?: (item: any) => void;
    onSerieClick?: (item: any) => void;
}

const SquadflixItemsRow = (props: Props) => {
    const {onMovieClick, onSerieClick} = props;
    const {items: torrestreamItems, loading} = useSquadflixOriginalsData();
    const squadflixNav = UseSquadflixNavigate({});

    if (loading) return null;
    if (!torrestreamItems || torrestreamItems.length === 0) return null;
    return (
        <div style={{height: "290px", overflow: "hidden", width: "100%", order: props.order ?? 0}}>
            <SquadflixRowTitle
                title="SquadFlix Originals" icon={<i className="fa-solid fa-certificate"></i>}
                {...props}/>
            <ItemsHorizontalScroll>
                {torrestreamItems.map((item) => (
                    <ItemTmdbBtnV2
                        key={item.id}
                        onClick={() => {
                            if (item.isMovie) {
                                onMovieClick ? onMovieClick(item) : squadflixNav.navigateToMovie(item);
                            } else {
                                onSerieClick ? onSerieClick(item) : squadflixNav.navigateToSerie(item);
                            }
                        }}
                        bottomInfo={<>{item.vote_average.toFixed(1)}<i
                            className="fa-solid fa-star fa-sm text-warning ps-1"></i></>}
                        tmdbItem={item}
                        type={item.isMovie ? "movie" : "tv"}
                        description={item.first_air_date ?? item.release_date}
                    />
                ))}
            </ItemsHorizontalScroll>
        </div>
    );
};

export default SquadflixItemsRow;
